import {ChatMessage, DataObjectId, SandboxTree} from 'yougile-model'
import {ChatMessageData} from '@components/common/base/chat-message'
import {useUserName} from '@components/common/base/user-name'
import {EmojiUtils} from '@extensions/emoji-utils'
import {MessageUtils} from '@extensions/message-utils'
import {extractFiles} from './extract-files'

export const useForwardedMessageData = (
  box: SandboxTree,
  msg?: ChatMessage
): ChatMessageData | undefined => {
  const userId = msg?.properties.originalAuthorId as DataObjectId
  const {name: userName, type: userNameType} = useUserName({
    userId,
    guestId: userId
  })
  if (!msg?.properties.forwardingAuthorId) {
    return undefined
  }
  const text = msg.isTextHtml() ? msg.getTextHtml() : msg.text
  return {
    userName,
    userNameType,
    html: MessageUtils.renderHtmlForView(box, msg),
    timestamp: msg.timestamp,
    emojiOnly: EmojiUtils.isShortEmoji(text),
    my: false,
    files: extractFiles(msg)
  }
}
